import React from 'react';
import { ActMapARL, ActMapFactory2, ActMapFactory3, ActMapShowroomWise, ActMapShowroomWicanders, ActMapComponentsAndFinishing } from '../acts-map';

export const components = ["milling", "cork-veneers-production", "agglomeration", "composite-cork-agglomeration", "top-layer", "painting", "sanding", "composite-core-assembling"];
export const finishing1 = ["digital-printing", "hdf-assembling", "cutting", "packaging"];
export const finishing2 = ["cutting-af2", "packaging-af2"];
export const showroom = [
  "showroom", "amorim-group-business-units", "amorim-cork", "amorim-wood", "amorim-stone", "amorim-dekwall", "amorim-floor-wall", "entrance", "cork-benefits",
  "cork-inspire-700-hrt", "wood-inspire-700-srt", "wood-inspire-700-hrt", "wood-pro-hrt", "stone-inspire-700", "stone-pure", "dekwall", "cork-pure-floor-and-wall",
  "cork-pure-signature-floor-and-wall", "cork-go", "cork-essence", "wood-go", "wood-resist", "wood-infinitus", "wood-resist-go", "wood-essence", "wood-hydrocork", "stone-essence",
];
export const aerialView = ["arl", "raw-material", "aerial-view"];

const MapComponent = ({ name = "factory", mini = false, currentSite }) => {

  if (components.find(id => id === name))
    return <ActMapComponentsAndFinishing name={name} mini={mini} />

  else if (finishing1.find(id => id === name))
    return <ActMapFactory2 name={name} mini={mini} />

  else if (finishing2.find(id => id === name))
    return <ActMapFactory3 name={name} mini={mini} />

  else if (showroom.find(id => id === name) && currentSite === "wicanders")
    return <ActMapShowroomWicanders id={name} mini={mini} />

  else if (showroom.find(id => id === name) && currentSite === "wise")
    return <ActMapShowroomWise id={name} mini={mini} />

  else if (aerialView.find(id => id === name))
    return <ActMapARL name={name} mini={mini} />

  else return null;
}
export default MapComponent;